<bn-loading-overlay></bn-loading-overlay>
<form id="form" name="form" class="form" [formGroup]="formGroup">
    <div class="row mt-5">
        <div class="col">
            <h5>Qualificação Inicial do Projeto</h5>
        </div>
    </div>

    <ng-container *ngIf="respostasQuestionario">
        <div formArrayName="respostas" *ngFor="let respostaControl of respostasQuestionario.controls; let i = index"
            class="box-pergunta">
            <div [hidden]="esconderPerguntaPorTipoTomador(listaPerguntas[i])">
                <ng-container *ngIf="!listaPerguntas[i].grupo">
                    <div class="row">
                        <div class="bn-form-group col-md-12">
                            <span class="titulo-pergunta">
                                {{listaPerguntas[i].ordem}} )
                                <span [innerHTML]="listaPerguntas[i].frontTitulo"></span>
                            </span>
                            <br />
                            <span class="subtitulo-pergunta" [innerHTML]="listaPerguntas[i].frontSubtitulo"></span>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="listaPerguntas[i].grupo && listaPerguntas[i].frontIsPerguntaNovoGrupo">
                    <div class="row">
                        <div class="bn-form-group col-md-12">
                            <span class="titulo-pergunta">
                                {{listaPerguntas[i].grupo.ordem}} )
                                <span [innerHTML]="listaPerguntas[i].grupo.frontTitulo"></span>
                            </span>
                            <br />
                            <span class="subtitulo-pergunta"
                                [innerHTML]="listaPerguntas[i].grupo.frontSubtitulo"></span>

                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="listaPerguntas[i].grupo">
                    <div class="row col-md-12">
                        <label class="form-label label-pergunta-grupo">
                            <span [innerHTML]="listaPerguntas[i].frontSubtitulo"></span>
                        </label>
                    </div>
                </ng-container>

                <div [formGroupName]="i">
                    <div class="row">
                        <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'radio'">
                            <div *ngFor="let opcaoResposta of listaPerguntas[i].listaOpcoes"
                                class="bn-form-group col-md-12">
                                <label class="form-label label-resposta">
                                    <input type="radio" formControlName="resposta" [value]="opcaoResposta.id"
                                        id="{{'radio'+ opcaoResposta.id}}">
                                    {{opcaoResposta.texto}}
                                </label>
                            </div>
                        </ng-container>
                    </div>
                    <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'checkbox'">
                        <div class="row">
                            <div formArrayName="resposta">
                                <div *ngFor="let opcaoResposta of listaPerguntas[i].listaOpcoes;let j = index"
                                    class="bn-form-group col-md-12">
                                    <label class="form-label label-resposta">
                                        <input type="checkbox" [formControlName]="j" [value]="opcaoResposta.id"
                                            id="{{'checkbox'+ opcaoResposta.id}}"
                                            (change)="checkboxChange($event, opcaoResposta, listaPerguntas[i].id)">
                                        {{opcaoResposta.texto}}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="listaPerguntas[i].frontMostrarTextoComplementar">
                            <div class="row">
                                <div class="col-md-6">
                                    <input type="text" formControlName="textoComplementar"
                                        class="form-control text-resposta" id="{{'text'+ listaPerguntas[i].id}}">
                                </div>
                            </div>
                        </div>

                    </ng-container>
                    <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'text'">
                        <div class="row">
                            <div class="bn-form-group {{getClassTamanhoPergunta(listaPerguntas[i])}}">
                                <input type="text" formControlName="resposta" class="form-control text-resposta"
                                    id="{{'text'+ listaPerguntas[i].id}}"
                                    bnMask="{{getMascaraPergunta(listaPerguntas[i].tipoValor)}}" casasDecimais="2"
                                    *ngIf="getMascaraPergunta(listaPerguntas[i].tipoValor)">
                                <input type="text" formControlName="resposta" class="form-control text-resposta"
                                    id="{{'text'+ listaPerguntas[i].id}}"
                                    *ngIf="!getMascaraPergunta(listaPerguntas[i].tipoValor)">
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'date'">
                        <div class="bn-form-group {{getClassTamanhoPergunta(listaPerguntas[i])}}">
                            <bn-datepicker formControlName="resposta">
                            </bn-datepicker>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="getTipoInput(listaPerguntas[i]) == 'custom'">
                        <ng-container *ngIf="listaPerguntas[i].frontCustomTemplate">
                            <ng-container
                                *ngTemplateOutlet="listaPerguntas[i].frontCustomTemplate; context: {fg: respostasQuestionario.controls[i] }">
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>

</form>


<ng-template #RESPONSAVEL_PELA_AVALIACAO let-fg="fg">
    <ng-container [formGroup]="fg">
        <div class="row box-pergunta-custom">
            <div class="bn-form-group col-md-3">
                <label class="form-label" for="text_16_cnpj">CNPJ</label>
                <input type="text" formControlName="cnpj" class="form-control" id="text_16_cnpj" bnMask='CNPJ'>
            </div>
        </div>
        <div class="row box-pergunta-custom">
            <div class="bn-form-group col-md-3">
                <label class="form-label" for="text_16_cpf">CPF</label>
                <input type="text" formControlName="cpf" class="form-control" id="text_16_cpf" bnMask='CPF'>
            </div>
        </div>
        <div class="row box-pergunta-custom">
            <div class="bn-form-group col-md-6">
                <label class="form-label" for="text_16_nome">Nome</label>
                <input type="text" formControlName="nome" class="form-control" id="text_16_nome">
            </div>
        </div>
        <div class="row box-pergunta-custom">
            <div class="bn-form-group col-md-6">
                <label class="form-label" for="text_16_profissao">Profissão</label>
                <input type="text" formControlName="profissao" class="form-control" id="text_16_profissao">
            </div>
        </div>

        <div class="row">
            <div class="bn-form-group col-md-3 box-pergunta-custom">
                <label class="form-label" for="text_16_registro">Número Registro Profissional ou Certificação</label>
                <input type="text" formControlName="registro" class="form-control" id="text_16_registro">
            </div>
            <div class="bn-form-group col-md-3 box-pergunta-custom">
                <label class="form-label" for="text_16_orgao_registro">Órgão Emissor/Entidade de Certificação</label>
                <select class="form-select" formControlName="orgaoRegistro" id="text_16_orgao_registro">
                    <option value="CREA">CREA – Conselho Regional de Engenharia e Agronomia</option>
                    <option value="CMVP">CMVP – Certified Measurement and Verification Professional</option>
                    <option value="CEM">CEM - Certified Energy Manager</option>
                </select>
            </div>
            <div class="bn-form-group col-md-3 box-pergunta-custom"
                *ngIf="fg.get('orgaoRegistro')?.value?.toUpperCase() === 'CREA'">
                <label class="form-label" for="text_16_uf_orgao_registro">Unidade da federação</label>

                <select class="form-select" formControlName="unidadeFederacaoOrgao" id="text_16_uf_orgao_registro">
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                </select>
            </div>
        </div>

    </ng-container>

</ng-template>

<ng-template #MAQUINAS_EQUIPAMENTOS>
    <div class="table-responsive">
        <table class="table table-hover">
            <tbody>
                <tr *ngFor="let item of listaCodigoEquipamentosSelecionados; let i = index; trackBy: trackByFn">
                    <td class="text-center">
                        <span>
                            <a (click)="removerEquipamento(i)">
                                <i class="text-danger fa fa-trash cursor-pointer"></i>
                            </a>
                        </span>
                    </td>
                    <td>
                        <select 
                            class="form-select" 
                            [id]="'equipamento-' + i" 
                            [name]="'equipamento-' + i"
                            [(ngModel)]="item.codigoFiname"
                            (ngModelChange)="salvarMudanca()">
                            <option [ngValue]="null">(selecione os equipamentos)</option>
                            <option *ngFor="let tipo of getOpcoesDisponiveis(item)" [value]="tipo.codigoFiname">
                                {{tipo.nomeItem}}
                            </option>
                        </select>
                    </td>
                    <td>
                        <input 
                            type="number" 
                            [id]="'qt-equipamento-' + i"
                            min="1"
                            max="1000"
                            class="form-control" 
                            [(ngModel)]="item.quantidade"
                            placeholder="(Informe a quantidade)">
                    </td>
                </tr>
            </tbody>
        </table>
        <a (click)="adicionarEquipamento()"><i class="fa fa-plus-circle cursor-pointer"></i></a>
    </div>
 </ng-template>


<div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="row">
        <div class="table-responsive col-auto">
            <table class="table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">Erro(s) encontrado(s)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ocorrencia of ocorrencias">
                        <td>{{ ocorrencia.mensagem }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
